import React, { useEffect, useState } from 'react'
import { doctors } from '../../Assets/dummyDoc'
import Header from '../Core/Header'
import { log10 } from 'chart.js/helpers'
import { useSelector } from 'react-redux'
import { getAllDoctor, sendRequestDoctor } from '../../service/operations/api_methods'
import { baseURLImg } from '../../service/api_endpoints'
import { toast } from 'sonner'

const FindDoctors = () => {
     const[list,setList]=useState(doctors)
      const token=useSelector((state)=>state?.auth?.token)

     const [doctorsList,setDoctorsList]=useState([])
     const [searchkey,setSearchKey]=useState("")

     const handleGetAlldoctors=async()=>{
        try {
            const res =await getAllDoctor(token)
            console.log('getAllDoctor',res.data.data);
            if(res.status===200){
                setDoctorsList(res.data.data)
            }
            
        } catch (error) {
          console.log(error);
            
        }
     }

     const handleRequestAssign=async(id)=>{
        try {let data={doctor_user_id:id}
            const res=await sendRequestDoctor(token,data)
            console.log(res);
            if(res.status===200 && res.data.success===true){
                toast.success(res.data.message)
            }
            
        } catch (error) {
            console.log(error);
            
        }
     }


     useEffect(() => {
       handleGetAlldoctors()
     }, [])


     let filterdeList=doctorsList
     
  return (
    <div style={{height:"100vh",width:"100%",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)"}}>
      <Header/>
      <section style={{marginTop:"80px",height:"calc(100vh - 80px)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-between",padding:"6px",backgroundColor:"#868686",borderRadius:"5px"}}>
            <p style={{color:"white",fontWeight:"500"}}>All registered Doctors </p>
            <input placeholder='Search Doctors '
            value={searchkey} onChange={(e)=>setSearchKey(e.target.value)}
            style={{border:"0.5px solid white",
                borderRadius:"8px",
                fontSize:"16px",padding:"5px",
                backgroundColor:"white",
                outline:"none"
            }}/>
             
            </div>
        <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"100%",overflowY:"auto",overflowX:"hidden"}}>
            {
            doctorsList.map((item)=>(
                <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    {item?.alreadyMapped===false &&
                    <p onClick={()=>handleRequestAssign(item?.user_id)}
                    style={{padding:"10px",borderRadius:"5px",backgroundColor:item.requestStatus==="PENDING"?"rgb(63, 90, 131)":"#042b64ff",color:"white",fontSize:"14px",cursor:item.requestStatus==="PENDING"?"not-allowed":"pointer",
                        position:"absolute",right:"30px"
                    }}>
                       {item.requestStatus==="PENDING"?"Requested":" Send Request"}</p>}
                    <img src={`${baseURLImg}${item?.user?.profile_image}`} style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item?.user?.first_name}  {item?.user?.last_name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'12px',fontWeight:"500",color:"#d65d3eff"}}>D.o.b:{item?.user?.dob}</span>
                            <span style={{fontSize:'12px',fontWeight:"500",color:"#6fa0d8ff"}}>{item?.user?.email}</span></p>
                            <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'12px',fontWeight:"500",color:"#d65d3eff"}}>Ph:{item?.user?.primary_number}</span>
                            <span style={{fontSize:'12px',fontWeight:"500",color:"#6fa0d8ff"}}>Specialist:{item?.specialist_type}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'12px',fontWeight:"500",color:"#a3343aff"}}>Exp:{item?.experience_years}</span>
                            <span style={{fontSize:'12px',fontWeight:"500",color:"#5456d6ff"}}>Med.Id:{item?.user?.medical_id}</span></p>
                    
                        
                     </div>

                    </div>
            ))
            }

        </div>

      </section>
    </div>
  )
}

export default FindDoctors
